<template>
    <div class="spinner-wrapper" :class="{'over': over}">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    over: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parentPosition: '',
      parentElement: null,
    };
  },
  mounted() {
    this.checkParentPosition();
  },
  beforeDestroy() {
    this.returnParentPosition();
  },
  methods: {
    checkParentPosition() {
      if (this.over) {
        this.parentPosition = this.$el.parentElement.style;
        this.parentElement = this.$el.parentElement;
        if (this.parentPosition !== 'absolute' || this.parentPosition !== 'fixed') {
          this.$el.parentElement.style.position = 'relative';
        }
      }
    },
    returnParentPosition() {
      if (this.over) {
        this.parentElement.style.position = this.parentPosition;
      }
    },
  },
};
</script>

<style scoped lang="scss">
    .spinner-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .lds-ripple {
        flex: 0 0 64px;
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
    }
    .lds-ripple div {
        position: absolute;
        border: 4px solid #ffcc00;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    .lds-ripple div:nth-child(2) {
        animation-delay: -0.5s;
    }

    .over {

        @at-root :root {
            position: relative;
        }

        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .6);
    }
    @keyframes lds-ripple {
        0% {
            top: 28px;
            left: 28px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: -1px;
            left: -1px;
            width: 58px;
            height: 58px;
            opacity: 0;
        }
    }

</style>
